import React, { FC, KeyboardEvent, ReactNode } from "react";
import {
  Card,
  Description,
  Footer,
  Head,
  Indicator,
  IndicatorCore,
  Main,
  Title,
  TitleRow,
  Trailing,
} from "./OptionCard.styled";

export interface V3OptionCardProps {
  selected: boolean;
  onSelect: () => void;
  title: string;
  description?: string;
  badge?: ReactNode;
  trailing?: ReactNode;
  disabled?: boolean;
  footer?: ReactNode;
  testID?: string;
}

const ACTIVATION_KEYS = ["Enter", " "];

export const V3OptionCard: FC<V3OptionCardProps> = ({
  selected,
  onSelect,
  title,
  description,
  badge,
  trailing,
  disabled = false,
  footer,
  testID,
}) => {
  const activate = () => {
    if (!disabled) onSelect();
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!ACTIVATION_KEYS.includes(event.key)) return;
    event.preventDefault();
    activate();
  };

  return (
    <Card
      role="radio"
      aria-checked={selected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={activate}
      onKeyDown={handleKeyDown}
      data-testid={testID}
      $selected={selected}
      $disabled={disabled}
    >
      <Head>
        <Indicator $selected={selected} aria-hidden="true">
          {selected ? <IndicatorCore /> : null}
        </Indicator>
        <Main>
          <TitleRow>
            <Title>{title}</Title>
            {badge}
          </TitleRow>
          {description ? <Description>{description}</Description> : null}
        </Main>
        {trailing ? <Trailing>{trailing}</Trailing> : null}
      </Head>
      {footer ? <Footer>{footer}</Footer> : null}
    </Card>
  );
};
